import { AnyAction } from 'redux'
import { updateUrl } from '../locationState/utils'

export const TEMPLATE_PURPOSES_UPDATE = 'TEMPLATE_PURPOSES_UPDATE'
export const SORTING_STRATEGY_UPDATE = 'SORTING_STRATEGY_UPDATE'
export const SET_VIEW_ID = 'SET_VIEW_ID'
export const QUICK_VIEW_ID_RESET = 'QUICK_VIEW_ID_RESET'
export const SET_IS_SIMILAR_PRODUCT = 'SET_IS_SIMILAR_PRODUCT'

export const setQuickViewId = (designId: string): AnyAction =>
  updateUrl({
    type: SET_VIEW_ID,
    payload: {
      designId,
    },
  })

export const resetQuickViewId = (designId?: string | null): AnyAction =>
  updateUrl({
    type: QUICK_VIEW_ID_RESET,
    payload: {
      designId,
    },
  })

export const setIsSimilarProduct = (isSimilarProduct: boolean): AnyAction =>
  updateUrl({
    type: SET_IS_SIMILAR_PRODUCT,
    payload: {
      isSimilarProduct,
    },
  })
